export default {"id":"3f6dc3fa","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}